include ../../../club/loading-table.mixin.pug

.fp-vertical-spacing.-s-sm
  .fp-vertical-spacing--line
    h2.fp-title.-color-shade-700 {{ t('auctionsPage.lastBids') }}
  .fp-vertical-spacing--line(v-if='bids.isLoading()' data-test='loading-bids')
    +loading-table
  .fp-vertical-spacing--line(v-if='!hasBids' data-test='no-bids')
    p {{ t('auctionsPage.noBids') }}
  .fp-vertical-spacing--line(v-else)
    table.fp-table
      thead
        tr
          th {{ t('auctionsPage.bidsTable.date') }}
          th {{ t('auctionsPage.bidsTable.exclusive') }}
          th {{ t('auctionsPage.bidsTable.bidder') }}
          th {{ t('auctionsPage.bidsTable.price') }}
      tbody
        AuctionBidRowVue(v-for='(bid, index) in bids.value()' :key='index' :bid='bid' :index='index')
